// Shared date helpers — ONE source of truth so charts across files place a date at the SAME x.
// The six local `yearFrac` copies had disagreeing formulas (month*30/365 in the app charts vs
// month/12 in two admin ones), a latent overlay-alignment hazard (O3, docs/design/CODE_AUDIT_2026-07.md).
// Canonical form: whole year + EXACT day-of-year/365. The earlier month*30 approximation made the
// last day of every 31-day month collide with the 1st of the next (Jul 31 ≡ Aug 1 → the chart's
// stitched "today" point landed on yesterday's x and the tooltip couldn't reach it). UTC so the
// x-position never shifts with the viewer's timezone (ISO date-only strings parse as UTC midnight).
export const yearFrac = (s) => {
  const d = new Date(s);
  const y = d.getUTCFullYear();
  return y + (Date.UTC(y, d.getUTCMonth(), d.getUTCDate()) - Date.UTC(y, 0, 1)) / 86400000 / 365;
};
